import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import appActions from '../../../appActions';
import storage from '../../../utils/storage';

const AccessControl = (props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const token = storage.get('session');

    useEffect(() => {
        if (!token) {
            navigate('/', { replace: true });
        }
    }, [navigate, token]);

    const fetchPriorityList = useCallback((params = {}) => {
        dispatch(appActions.PRIORITY_GET_ALL_REQUEST({ ...params }));
    }, [dispatch]);

    const fetchTimeZoneList = useCallback((params = {}) => {
        dispatch(appActions.TIMEZONE_GET_ALL_REQUEST({ ...params }));
    }, [dispatch]);

    // const fetchTaskTypeList = useCallback((params = {}) => {
    //     dispatch(appActions.TASKTYPE_GET_ALL_REQUEST({ ...params }));
    // }, [dispatch]);

    const fetchRepeatList = useCallback((params = {}) => {
        dispatch(appActions.REPEAT_GET_ALL_REQUEST({ ...params }));
    }, [dispatch]);

    const fetchProgressList = useCallback((params = {}) => {
        dispatch(appActions.PROGRESS_GET_ALL_REQUEST({ ...params }));
    }, [dispatch]);

    const fetchStoreList = useCallback((params = {}) => {
        dispatch(appActions.STORE_GET_ALL_REQUEST({ ...params }));
    }, [dispatch]);

    const fetchSiteGroupList = useCallback((params = {}) => {
        dispatch(appActions.SITEGROUPLIST_GET_ALL_REQUEST({ ...params }));
    }, [dispatch]);
    
    const fetchUserList = useCallback((params = {}) => {
        dispatch(appActions.USERLIST_GET_ALL_REQUEST({ ...params }));
    }, [dispatch]);

    const fetchReminderList = useCallback((params = {}) => {
        dispatch(appActions.REMINDER_GET_ALL_REQUEST({ ...params }));
    }, [dispatch]);

    const fetchRolesList = useCallback((params = {}) => {
        dispatch(appActions.ROLESLIST_GET_ALL_REQUEST({ ...params }));
    }, [dispatch]);

    useEffect(() => {
        //Pre-Load for Task
        fetchPriorityList({ propCode: 'PRIORITY_TYPE', propGroup: 'TASK' });
        fetchTimeZoneList({ propCode: 'TIMEZONE', propGroup: 'Data' });
        // fetchTaskTypeList({ propCode: 'TASK_TYPE', propGroup: 'TASK' });
        fetchRepeatList({ propCode: 'REPEAT_TYPE', propGroup: 'TASK' });
        fetchProgressList({ propCode: 'PROGRESS_TYPE', propGroup: 'TASK' });
        fetchStoreList({ fetchAll: true });
        fetchSiteGroupList({ fetchAll: true });
        fetchUserList({ fetchAll: true });
        fetchRolesList({ propCode: 'USER_ROLE', propGroup: 'SYS' });
        fetchReminderList({ propCode: 'REMINDER_TYPE', propGroup: 'TASK' });
    }, []);

    return React.cloneElement(props.children);
};

export default AccessControl;
